<template>
  <nav>
    <div
      v-scroll-to="{
        el: `.${item.anchor}`,
        offset: -120,
        force: true,
      }"
      :class="[`nav-item nav-${item.anchor}`, index === 0 ? 'nav-active' : '']"
      v-for="(item, index) in data"
      :key="index"
    >{{ item.name }}</div>
  </nav>
</template>

<script>
export default {
  props: ["data"],
};
</script>

<style lang="scss">
.nav-item {
  color: #fff;
  font-size: 13px;
  display: inline-block;
  margin-right: 30px;
  position: relative;
  cursor: pointer;

  &:last-child {
    margin: 0;
  }

  &:after {
    transition: 0.3s linear;
    content: "";
    position: absolute;
    bottom: -20px;
    left: 50%;
    transform: translate(-50%, 0);
    width: 0;
    height: 2px;
    background: #fff;
  }
}

.nav-item:hover,
.nav-active {
  &:after {
    width: 100%;
  }
}
</style>